import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { asyncFetch } from '../../helperFunctions';
import { setSnackbar } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const refresh = async () => {
    const response = await asyncFetch(
      `${process.env.REACT_APP_TECHNICIANS_API}/Feature/refreshApp`,
      {},
      {},
      undefined,
      dispatch
    );

    if (response) {
      dispatch(setSnackbar({ open: true, message: response }));
    }
  };

  return (
    <Button
      onClick={() => refresh()}
      variant="contained"
      style={{
        margin: '2px',
        marginTop: '5px',
      }}
    >
      Refresh All Technician Apps
    </Button>
  );
};
